module.exports = __webpack_public_path__ + "img/img60.73c2ef3b.png";